import React from 'react';

import storyStepper from 'src/assets/starterDashboardV2/readyToShare/storyStepper.svg';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { HeaderStyles, RectangleShapeStyles, SkeletonContainerStyles, StoryStepperStyles } from './Header.styles';
import type { InstagramStoryComponentsProps } from './types';

export function Header(props: InstagramStoryComponentsProps): React.JSX.Element {
	const { size, loading } = props;
	const styles = HeaderStyles({ size });
	const rectangleStyles = RectangleShapeStyles({ size });

	return (
		<div className={styles}>
			<img className={StoryStepperStyles({ size })} src={storyStepper} alt="" aria-hidden />
			<SkeletonContainer
				className={SkeletonContainerStyles({ size })}
				shapeColorClassName="bg-icon-weak"
				shapeSize={size}
				loading={loading}
			>
				<Circle />
				<Rectangle className={rectangleStyles} rounded />
			</SkeletonContainer>
		</div>
	);
}
